export default {
	bind: function(el) {
		let oDiv = el; // 获取当前元素
		oDiv.style.cssText += ';cursor:move;'
		oDiv.onmousedown = (e) => {
			let disX = e.clientX - oDiv.offsetLeft;
			let disY = e.clientY - oDiv.offsetTop;

			oDiv.onmousemove = (e) => {
				let left = e.clientX - disX;
				let top = e.clientY - disY;

				oDiv.style.left = left + 'px';
				oDiv.style.top = top + 'px';
			};

			oDiv.onmouseup = (e) => {
				oDiv.onmousemove = null;
				oDiv.onmouseup = null;
			}
		}
	}
}


